<header class="flex flex-wrap items-center px-4 py-2 border-b border-light-blue">
  <div class="flex flex-wrap items-center mr-4 my-2">
    <img [ngSrc]="ecoLogoUrl"
         width="91" height="30" alt="Eco logo" priority>
    <h1 class="mx-3 text-xl">{{ message('navTitle') }}</h1>
    <button class="pt-0.5 cursor-pointer hover:opacity-80"
            (mouseenter)="retrieveReleaseNotes()" (focus)="retrieveReleaseNotes()"
            (click)="openReleaseNotes()">
      {{ release }}
    </button>
  </div>
  <div class="mr-auto my-2">
    <button mat-stroked-button class="mx-2" (click)="openImportDialog()">{{ message('importHeader') }}</button>
    <button mat-stroked-button class="mx-2" (click)="openExportDialog()">{{ message('exportHeader') }}</button>
  </div>
  <div class="my-2 flex flex-wrap items-center">
    <button class="material-icons mx-3 cursor-pointer hover:opacity-80" (click)="openSettingsDialog()">settings</button>
    <mat-form-field appearance="outline" class="mx-3 min-w-36">
      <mat-label>{{ message('serverLabel') }} ({{ message('betaLabel') }})</mat-label>
      <mat-select [value]="selectedServerId()"
                  (selectionChange)="onServerChange($event.value)"
                  [attr.aria-label]="message('selectServerLabel')" panelClass="select-dropdown">
        @for (serverGroup of serverGroups; track serverGroup.id) {
          <mat-optgroup [label]="serverGroupLabel(serverGroup)">
            @for (server of serverGroup.servers(); track server.id) {
              <mat-option [value]="server.id">
                {{ serverOptionLabel(server) }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="mx-3">
      <mat-select [value]="selectedLocale().code" (selectionChange)="onLocaleChange($event.value)"
                  aria-label="Select locale" panelClass="select-dropdown">
        @for (locale of supportedLocales; track locale.code) {
          <mat-option [value]="locale.code" class="f16">
            <span [class]="'flag ' + locale.regionCode"></span>
            <span class="ml-2">{{ locale.name }}</span>
          </mat-option>
        }
      </mat-select>
      <div matPrefix class="f16">
        <span [class]="'flag ' + selectedLocale().regionCode"></span>
      </div>
    </mat-form-field>
    <span class="mx-3">{{ message('version') }} 12.0.7</span>
  </div>
</header>
